import * as Sentry from '@sentry/angular';
import { throwError } from 'rxjs';
import { Injectable } from '@angular/core';

interface SentryExceptionTag {
  requestURL: string;
  pageURL: string;
  errorMessage: string;
  errorStatusCode: number;
  timestamp: string;
}
@Injectable({
  providedIn: 'root',
})
export class ErrorService {
  logError(err: any) {
    throwError(new Error(err));
  }
}

export const captureSentryException = (sentryException: SentryExceptionTag) => {
  Sentry.setTag('StatusCode', sentryException.errorStatusCode);
  Sentry.captureException(sentryException);
};
